import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import OrbitalMenu from "./OrbitalMenu";
import Profile from "../../Assets/Profile.png"
import Icon from '@mui/material/Icon';
import ComputerIcon from '@mui/icons-material/Computer';
import StorageIcon from '@mui/icons-material/Storage';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SpeedIcon from '@mui/icons-material/Speed';

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <OrbitalMenu />
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Behind the Screen:  <span className="purple"> Who Am I </span> 🤷‍♂️
            </h1>
            <p className="home-about-body">
            With 3+ years of experience in Software Engineering, AI, and database solutions, I specialize in building 
            scalable, high-performing systems that power the future. My goal is to help businesses and individuals develop and optimize
             their applications and workflows, ensuring everything runs smoothly and efficiently.
             </p>           
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={Profile} className="img-fluid image-container" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
        <section class="expertise">
            <h2 class="purple left-align">What I Bring to the Table 🔥</h2>
            <div class="grid ">
              <div class="grid-content">
                <div class="card-animate-view">
                  <ComputerIcon className="material-icons" />
                  <h5>Software Development</h5>
                  <ul class="summary-text">
                    <li>Software development using C# (.NET, .NET Core), JavaScript (React, Redux)</li>
                    <li>Scalable architecture with Microservices & Docker</li>
                    <li>Message brokering with Kafka, Azure Service Bus & RabbitMQ</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <SmartToyIcon className="material-icons" />
                  <h5>AI Solutions</h5>
                  <ul class="summary-text">
                    <li>Model training, optimization, and deployment in AI, ML & GenAI</li>
                    <li>AI-powered solutions using Python, .NET, Azure & AWS</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <StorageIcon className="material-icons" />
                  <h5>Database Expertise</h5>
                  <ul class="summary-text">
                    <li>SQL optimization & query tuning</li>
                    <li>Working with SQL, ElasticSearch, Entity Framework & Dapper</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <SpeedIcon className="material-icons" />
                  <h5>Performance Optimization</h5>
                  <ul class="summary-text">
                    <li>System efficiency tuning </li>
                    <li>System efficiency monitoring & load testing with Stackify</li>
                    <li>Scalable, high-performance applications</li>
                  </ul>
                </div>
                
           
              </div>
              <div class="grid-content grid-content-second">
                <div class="card-animate-view">
                  <ComputerIcon className="material-icons" />
                  <h5>Software Development</h5>
                  <ul class="summary-text">
                    <li>Software development using C# (.NET, .NET Core), JavaScript (React, Redux)</li>
                    <li>Scalable architecture with Microservices & Docker</li>
                    <li>Message brokering with Kafka, Azure Service Bus & RabbitMQ</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <SmartToyIcon className="material-icons" />
                  <h5>AI Solutions</h5>
                  <ul class="summary-text">
                    <li>Model training, optimization, and deployment in AI, ML & GenAI</li>
                    <li>AI-powered solutions using Python, .NET, Azure & AWS</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <StorageIcon className="material-icons" />
                  <h5>Database Expertise</h5>
                  <ul class="summary-text">
                    <li>SQL optimization & query tuning</li>
                    <li>Working with SQL, ElasticSearch, Entity Framework & Dapper</li>
                  </ul>
                </div>
                <div class="card-animate-view">
                  <SpeedIcon className="material-icons" />
                  <h5>Performance Optimization</h5>
                  <ul class="summary-text">
                    <li>System efficiency tuning </li>
                    <li>System efficiency monitoring & load testing with Stackify</li>
                    <li>Scalable, high-performance applications</li>
                  </ul>
                </div>
                
           
              </div>
            </div>
        </section>


        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/jaweriasohail99"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://twitter.com/Soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jaweria-sohail-271179152/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      
      </Container>
    </Container>
  );
}
export default Home2;
